export const STATUS = {
  ACCEPT_BEFORE: 'ACCEPT_BEFORE',
  ACCEPT_WAITING: 'ACCEPT_WAITING',
  ACCEPT_ERROR: 'ACCEPT_ERROR',
  ACCEPT_SUCCESS: 'ACCEPT_SUCCESS',
};

export const UI_DATA = {
  ACCEPT_BEFORE: {
    title: 'Accept Offer',
    message: 'To accept this offer you need to execute a transaction.',
  },
  ACCEPT_WAITING: {
    title: 'Waiting for transaction..',
    message: 'Please approve the transaction in your wallet.',
  },
  ACCEPT_ERROR: {
    title: 'Error executing transaction',
    message: 'MetaMask Message Signature: User denied transaction signature.',
  },
  ACCEPT_SUCCESS: {
    title: 'Accept Succeed',
    message: 'You can close this window.',
  },
};
